import React from "react";
import { formatFecha } from "../ErrorLogs/formatFecha";
import { ESTADO, etiquetaContexto } from "./estados";

/**
 * El `id` de cada columna viaja al backend como `orderBy` (ver orderBy() en
 * DataTableHelper), asi que debe coincidir con el nombre de la columna en
 * `logs_wa`. Las columnas con `button: true` quedan fuera del filtro.
 */
const Columns = (detail) => {
  return [
    {
      id: "created_at",
      name: "Fecha",
      selector: (row) => formatFecha(row.created_at),
      sortable: true,
      width: "165px",
    },
    {
      id: "success",
      name: "Estado",
      selector: (row) => {
        const estado = ESTADO(row.success);
        return (
          <span className={`badge bg-${estado.color}`}>{estado.label}</span>
        );
      },
      sortable: true,
      width: "110px",
    },
    {
      id: "recipient_name",
      name: "Destinatario",
      selector: (row) => row.recipient_name ?? "-",
      sortable: true,
      wrap: true,
    },
    {
      id: "to",
      name: "Teléfono",
      selector: (row) => row.to ?? "-",
      sortable: true,
      width: "150px",
    },
    {
      id: "context",
      name: "Tipo de envío",
      selector: (row) => etiquetaContexto(row.context),
      sortable: true,
      wrap: true,
    },
    {
      id: "error_code",
      name: "Código",
      selector: (row) => row.error_code ?? "-",
      sortable: true,
      width: "100px",
    },
    {
      id: "provider",
      name: "Proveedor",
      selector: (row) =>
        [row.provider, row.channel].filter(Boolean).join(" / ") || "-",
      sortable: true,
      width: "150px",
    },
    {
      id: "actions",
      name: "Acciones",
      width: "100px",
      button: true,
      cell: (row) => (
        <div className="pe-2">
          <button
            className="btn btn-primary btn-sm"
            title="Ver detalle del envío"
            onClick={() => detail(row)}
          >
            <i className="fa fa-eye"></i>
          </button>
        </div>
      ),
    },
  ];
};

export default Columns;
